export default{
  saveLoginInfo({commit},data){
    commit('SAVE_LOGIN_INFO', data)
  },
  savePageLoad({commit},data){
    commit('SAVE_PAGE_LOAD',data)
  },
  saveUser({commit},data){
    commit('SAVE_USER',data)
  }
}



// WEBPACK FOOTER //
// ./src/store/axj-web/actions.js